module.exports = __webpack_public_path__ + "img/slideset-relateditems_active.511d8769.svg";